import { CDError } from 'utils/error';
import type { InferType } from 'yup';
import { validationSchema } from 'pages/Main/Settings/BankingLegal/constants';
import client from 'data/client';

export type ResponseStatus = {
  status: string;
};

export type AddressType = {
  city: string;
  country: string;
  state: string;
  line1: string;
  zip: string;
};

export type Payload = {
  legal_address: AddressType;
  device_info: object;
} & Omit<InferType<typeof validationSchema>, 'legal_address'>;

export const submitBIF = async (payload: Payload, orgId: string) => {
  const ZEUS_API_URL = import.meta.env.VITE_APP_ZEUS_API_URL;
  try {
    const response = await client.post(
      `${ZEUS_API_URL}bif/entry`,
      {
        ...payload,
        org_id: orgId,
      },
      {
        validateStatus: () => true,
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
    const body = response.data;
    const code = response.status;
    if (code !== 201) {
      if (typeof body.detail !== 'string') {
        if (Array.isArray(body.detail) && typeof body.detail[0] === 'string') {
          body.detail = body.detail.join('. ');
        } else if (Array.isArray(body.detail)) {
          // eslint-disable-next-line no-restricted-syntax
          for (const data of body.detail) {
            if (data?.loc && data.loc.includes('legal_address')) {
              body.detail = 'Please enter a valid legal address.';
              return { code, body };
            }
          }
          body.detail = 'Please check the form for errors.';
        }
      } else if (body.detail.includes('/type_details/routing_number')) {
        body.detail =
          'We were unable to verify your banking information. ' +
          'Please double-check that your routing number and account number are correct.';
      } else {
        body.detail =
          'We were unable to process your request. ' +
          'Please try again later or contact Superorder Support at support@superorder.com or 917-730-2987.';
      }
    }
    return { code, body };
  } catch (error) {
    // @ts-ignore
    throw new CDError(error.toString());
  }
};
